// extracted by mini-css-extract-plugin
export var footerContainer = "footer-module--footerContainer--votTC";
export var footerContent = "footer-module--footerContent--s+vzX";
export var hits = "footer-module--hits--tuDqc";